<template>
  <div class="content">
    <p class="ttile">
      商品搜索<span
        >(说明:底纹词配置好后，将在搜索框内自动上下滚动展示;热点词配置好后，以标签样式展示在页面，超出页面范围支持左右滑动展示。)</span
      >
    </p>
    <div class="set-content">
      <div class="set-item" style="margin-bottom: 20px;">
        <p class="title">底纹词配置（非必填）</p>
        <p class="dec">底纹词数量大于1，默认会自动上下滚动展示。</p>
        <UploadImgList
          v-model="curComponent.shadedWords"
          :maxLength="10"
          :minLength="0"
          :haveImg="false"
          :haveTitle="true"
          :haveJump="false"
          :titleMaxLength="20"
          addBtnText="添加底纹词"
          :templateParams="template"
        />
      </div>

      <div class="set-item select-type">
        <p class="title">热点词配置（非必填）</p>
        <UploadImgList
          v-model="curComponent.hotWords"
          :maxLength="10"
          :minLength="0"
          :haveImg="false"
          :haveTitle="true"
          jumpType="url"
          :titleMaxLength="20"
          addBtnText="添加热点词"
          :templateParams="template"
        />
      </div>

      <div class="set-item basic-set">
        <p class="title">样式基础设置</p>
        <SpRadio
          v-model="curComponent.positionType"
          style="margin-bottom: 20px;"
          label="固定位置"
          :options="[
            { label: '当前位置插入', value: 'default' },
            { label: '顶部', value: 'topPosition' }
          ]"
        />
        <SpRadio
          v-model="curComponent.searchStyle"
          style="margin-bottom: 20px;"
          label="搜索框样式"
          :options="[
            { label: '圆形', value: 'round' },
            { label: '方形', value: 'square' }
          ]"
        />
        <SpRadio
          v-model="curComponent.textPosition"
          style="margin-bottom: 20px;"
          label="文本位置"
          :options="[
            { label: '居左', value: 'flex-start' },
            { label: '居中', value: 'center' }
          ]"
        />
        <SpSlider
          v-model="curComponent.searchHeight"
          :min="28"
          :max="60"
          label="框体高度"
        />
        <SpPickerColor
          v-model="curComponent.backgroundColor"
          :isGradient="true"
          defaultColor="#CBCBCB"
          label="背景颜色"
        />
        <SpPickerColor
          v-model="curComponent.searchBgColor"
          defaultColor="#ffffff"
          label="框体颜色"
        />
        <SpPickerColor
          v-model="curComponent.buttonColor"
          defaultColor="#00BC71"
          label="按钮颜色"
        />
        <SpPickerColor
          v-model="curComponent.buttonTextColor"
          defaultColor="#ffffff"
          label="按钮文字颜色"
        />
        <SpPickerColor v-model="curComponent.textColor" label="文字颜色" />
      </div>
    </div>
  </div>
</template>

<script>
import SpRadio from "../../../components/SpRadio";
import SpSlider from "../../../components/SpSlider";
import UploadImgList from "../../../components/UploadImgList";
import SpPickerColor from "../../../components/SpPickerColor";
export default {
  components: {
    SpRadio,
    SpSlider,
    UploadImgList,
    SpPickerColor
  },
  inject: ["control"],
  computed: {
    curComponent: {
      get() {
        return this.control.curComponent;
      },
      set(val) {
        this.control.curComponent = val;
      }
    }
  },
  data() {
    return {
      visibleHotSpot: false,
      template: {
        path: "",
        title: ""
      }
    };
  },
  methods: {
    addHotSpot() {
      if (!this.curComponent.img.imgUrl) {
        this.$message.error("请上传图片");
        return;
      }
      this.visibleHotSpot = true;
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  .ttile {
    padding: 22px 24px 20px 24px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    font-weight: 500;
    span {
      font-size: 10px;
      color: #999999;
      padding-left: 10px;
    }
  }
  > .set-content {
    padding-top: 15px;
    padding: 20px 24px;
    > .select-type {
      /deep/ .sp-radio {
        margin-bottom: 20px;
      }
    }
    > .set-item {
      /deep/ .upload-img-slot {
        flex: 1;
        .el-button {
          padding: 4px 14px;
          color: #000000;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          border: none;
          color: #fff;
          background: #2154f4;
        }
        div {
          font-size: 14px;
          color: #333;
          .el-button {
            margin-top: 10px;
          }
        }
      }
      > .title {
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 12px;
      }
      > .dec {
        font-size: 12px;
        color: #999999;
        font-weight: 400;
        margin-bottom: 20px;
      }
      > .select-view {
        margin-top: 12px;
        > span {
          font-size: 12px;
          font-weight: 400;
        }
        > span:first-child {
          color: #999999;
        }
        > span:last-child {
          color: #333333;
          padding-left: 10px;
        }
      }
    }
    > .add-img {
      margin-top: 30px;
    }

    > .basic-set {
      margin-top: 30px;
      /deep/ .slider-content,
      .picker-color {
        margin-bottom: 17px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/GoodsSearch/Attr.vue